import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SchemaLine } from 'src/app/project/project-schema/shared/interfaces/schema-line.class';
import { ProjectRouteStationWithParam } from 'src/app/project/shared/interfaces/project-route-station.class';
import { ProjectDataService } from 'src/app/project/shared/services/project-data.service';
import { MetaInformationService } from 'src/app/project/shared/services/meta-information.service';
import { ProjectGroupMetaInformation } from 'src/app/project/shared/interfaces/project-group-meta-information';
import { getMetaInformationLabel } from 'src/app/project/shared/functions/meta-information-label';

@Component({
  selector: 'avs-swa-line-parameter',
  templateUrl: './swa-line-parameter.component.html',
  styleUrls: ['./swa-line-parameter.component.css']
})
export class SwaLineParameterComponent implements OnDestroy {

  routeStations?: ProjectRouteStationWithParam[];
  public width: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  public unassignedStations: ProjectRouteStationWithParam[] = [];
  public metaInformation: ProjectGroupMetaInformation[] = [];

  public projectRouteStationsWithParamSubscription?: Subscription;
  public activeGroupSubscription?: Subscription;


  public line: SchemaLine = new SchemaLine([],[]);

  constructor(
    private projectDataService: ProjectDataService,
    private metaInfoService: MetaInformationService
  ) {
    this.projectRouteStationsWithParamSubscription = this.projectDataService.projectsRouteStationsWithParam.subscribe(routeStations => {
      if (routeStations) {
        this.routeStations = routeStations;
        this.sortRouteStationsIntoLine(routeStations);
      }
      else {
        this.routeStations = [];
        this.sortRouteStationsIntoLine([]);
      }
    });
    this.activeGroupSubscription = this.projectDataService.activeGroup.subscribe(group => {
      if (group) {
        this.loadMetaInformation(group.id);
      } else {
        this.metaInformation = [];
      }
    });
  }

  public ngOnDestroy(): void {
    this.projectRouteStationsWithParamSubscription?.unsubscribe();
    this.activeGroupSubscription?.unsubscribe();
  }

  private loadMetaInformation(groupId: number): void {
    this.metaInfoService.getMetaInformationByGroupId(groupId).subscribe((metaInfo: ProjectGroupMetaInformation[]) => {
      this.metaInformation = metaInfo ?? [];
    });
  }

  public getPositionLabel(x: number, y: number): string {
    return getMetaInformationLabel(this.metaInformation, x, y);
  }

  public sortRouteStationsIntoLine(routeStations: ProjectRouteStationWithParam[]): void {
    this.line = new SchemaLine(
      [{ station: undefined, x: 1, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 2, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 3, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 4, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 5, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 6, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 7, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 8, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 9, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 10, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 11, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 12, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 13, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 14, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 15, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 16, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 17, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 18, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 19, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 20, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 21, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 22, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 23, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 24, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 25, isActive: false, line: [], colorArr: [] }
      ],

      [{ station: undefined, x: 1, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 2, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 3, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 4, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 5, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 6, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 7, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 8, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 9, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 10, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 11, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 12, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 13, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 14, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 15, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 16, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 17, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 18, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 19, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 20, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 21, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 22, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 23, isActive: false, line: [], colorArr: [] }, { station: undefined, x: 24, isActive: false, line: [], colorArr: [] },
      { station: undefined, x: 25, isActive: false, line: [], colorArr: [] }
    ]);

    let widthA: number[] = [150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150];
    let widthB: number[] = [150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150];

    for (let station of routeStations) {
      if (station.routeStation.y === 1) {
        if (station.routeStation.x > 0 && station.routeStation.x < this.line.areaA.length+1 && station.routeStation.x < widthA.length+1) {
          if (this.line.areaA[station.routeStation.x - 1].station) {
            this.line.areaA[station.routeStation.x - 1].station?.push(station);
            widthA[station.routeStation.x - 1] += 300;
          } else {
            this.line.areaA[station.routeStation.x - 1].station = [station];
            widthA[station.routeStation.x - 1] = 300;
          }
        } else {
          this.unassignedStations.push(station);
        }
      } else if (station.routeStation.y === 2) {
        if (station.routeStation.x > 0 && station.routeStation.x < this.line.areaB.length+1 && station.routeStation.x < widthB.length+1) {
          if (this.line.areaB[station.routeStation.x - 1].station) {
            this.line.areaB[station.routeStation.x - 1].station?.push(station);
            widthB[station.routeStation.x - 1] += 300;
          } else {
            this.line.areaB[station.routeStation.x - 1].station = [station];
            widthB[station.routeStation.x - 1] = 300;
          }
        } else {
          this.unassignedStations.push(station);
        }
      } else {
        this.unassignedStations.push(station);
      }
    }

    for (let index = 0; index < this.width.length && index < widthA.length && index < widthB.length; index++) {
      this.width[index] = widthA[index] > widthB[index] ? widthA[index] : widthB[index];
    }
    this.getHighestXAndCollapse()
  }

  public getHighestXAndCollapse() {
    let highestX = 0;
    this.routeStations?.forEach((station) => {
      if (station.routeStation.x > highestX) {
        highestX = station.routeStation.x;
      }
    });

    for (let index = highestX; index < 25; index++) {
      this.line.areaA[index].isHidden = true;
      this.line.areaB[index].isHidden = true;
    }
  }
}
